import React from 'react'
import ErrorPage from '../../components/ErrorPage'

const Error500 = () => (
  <ErrorPage
    statusCode={500}
    icon="warning sign"
    title="エラーが発生しました"
    action="時間をおいて、ページを再読み込みしてください。解決しない場合は、担当者にご連絡ください。"
  />
)

export default Error500
